export class Feedback {
  feedbackId: number;
  memberId: string;
  rating: number;
  notes: string;
  url: string;
  orgId: number;
  orgLevel: number;
  addedDttm: Date;
  addedBy: number;
}
